import './ExpandableText.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var root = _7a468({defaultClassName:'_19jh2ut0-3-15-1',variantClassNames:{expanded:{true:'_19jh2ut1-3-15-1',false:'_19jh2ut2-3-15-1'}},defaultVariants:{},compoundVariants:[]});